import React, { useEffect } from 'react';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Tooltip from '@material-ui/core/Tooltip';
import { Box, Checkbox, FormControlLabel } from '@material-ui/core';
import { parseCourseVersionForTree, SUBJECT_UNASSIGNED } from '../../../Utils/helper/schedulerHelper';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import _ from 'lodash';

const useItemStyles = makeStyles((theme) => ({
  root: {
    '& > .MuiTreeItem-content': {
      height: '35px',
    },
    '& > .MuiTreeItem-content > .MuiTreeItem-label': {
      display: 'flex',
      alignItems: 'center',
      padding: '4px 0',
      background: 'transparent !important',
      pointerEvents: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      padding: '0 15px 15px',
    },
    '& > .MuiTreeItem-content  > .MuiTreeItem-label::before': {
      content: "''",
      display: 'inline-block',
      minWidth: 15,
      minHeight: 15,
      marginRight: 8,
      border: '1px solid #ccc',
      background: 'white',
    },
  },
  iconContainer: {
    marginRight: 3,
    marginLeft: 0,
    '& > svg': {
      '&:hover': {
        opacity: 0.6,
      },
    },
  },
  label: {
    padding: 0,
  },
  selected: {
    '& > .MuiTreeItem-content  > .MuiTreeItem-label::before': {
      background: theme.palette.primary.main,
      // content: '\f095',
      border: '1px solid #ccc',
      // fontFamily: 'Font Awesome 5 Free',
    },
  },
  tooltipTable: {
    minWidth: ' 250px',
    maxWidth: '100%',
    padding: '30px',
    borderCollapse: ' collapse',
    background: '#ffffff',
    padding: '10px',
  },
  tooltipTable_Tr: {
    height: '25px',
    color: '#7A869A',
    fontSize: '12px',
    background: '#fff',
  },
  tooltipTable_td: {
    height: '25px',
    paddingLeft: '10px',
    color: '#7A869A',
    // background: '#f4f6fc',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    // borderLeft: '1px solid #303030',
    fontSize: '12px',
  },
  tooltipTable_th: {
    height: '25px',
    paddingLeft: '10px',
    color: 'rgb(9, 38, 130)',
    background: '#ffffff',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
  },
}));



export default function SubjectSectionSelector(props) {
  const { data = [], onSelectedChange } = props;

  const [dataNew, setDataNew] = React.useState();
  const [selected, setSelected] = React.useState([]);
  const [expanded, setExpanded] = React.useState([]);
  const classesItem = useItemStyles();

  useEffect(() => {
    console.log('SubjectSecionSelector: useEffect: ', data);
    // mark all selected
    if (data) {
      const s = parseCourseVersionForTree(data);
      setDataNew(s);
      setSelected([...getChildById(s, '0'), SUBJECT_UNASSIGNED]);
      setExpanded(['0']);
    }
  }, [data]);

  useEffect(() => {
    onSelectedChange(selected);
  }, [selected]);


  const handleToggle = (event, nodeIds) => {
    setExpanded(nodeIds);
  };

  const handleUnassigned = (event) => {
    // unassigned remove or add in selected array
    setSelected(_.xor(selected, [SUBJECT_UNASSIGNED]))
    console.log('Selected: ', selected, _.xor(selected, SUBJECT_UNASSIGNED))
  }

  //node is always the root "Parent"
  //id is id of node clicked
  function getChildById(node, id) {
    let array = [];

    //returns an array of nodes ids: clicked node id and all children node ids
    function getAllChild(nodes = null) {
      if (nodes === null) return [];
      array.push(nodes.id);
      if (Array.isArray(nodes?.children)) {
        nodes.children.forEach((node) => {
          array = [...array, ...getAllChild(node)];
          array = array.filter((v, i) => array.indexOf(v) === i);
        });
      }
      return array;
    }

    //returns the node object that was selected
    function getNodeById(nodes, id) {
      if (nodes?.id === id) {
        return nodes;
      } else if (Array.isArray(nodes?.children)) {
        let result = null;
        nodes.children.forEach((node) => {
          if (!!getNodeById(node, id)) {
            result = getNodeById(node, id);
          }
        });
        return result;
      }

      return null;
    }

    return getAllChild(getNodeById(node, id));
  }

  function getOnChange(checked, nodes) {
    //gets all freshly selected or unselected nodes
    const allNode = getChildById(dataNew, nodes.id);
    //combines newly selected nodes with existing selection
    //or filters out newly deselected nodes from existing selection
    let array = checked
      ? [...selected, ...allNode]
      : selected.filter((value) => !allNode.includes(value));

    console.log('Selected:', array);
    setSelected(array);
    // onSelectedChange(array)
  }
  const BlueOnGreenTooltip = withStyles({
    tooltip: {
      color: 'lightblue',
      border: '1px solid #fff',
      borderRadius: '4px',
      background: '#ffffff',
      boxShadow: '-2px 1px 8px 1px #737f8d',
    },
  })(Tooltip);

  const HeaderTable = (
    <tr className={classesItem.tooltipTable_Tr}>
      <th className={classesItem.tooltipTable_th}></th>
      <th className={classesItem.tooltipTable_th}>Required</th>
      <th className={classesItem.tooltipTable_th}>Allocated</th>
    </tr>
  );

  const ToolTiptext = ({ nodes }) =>
    data?.map((e, i) => {
      if (e.courseName === nodes.courseName) {
        const childData = Object.values(e.Allocated);
        const childDataKey = Object.keys(e.Allocated);
        const childRequiredData = Object.values(e.Required);

        if (!e.Required.Total) {
          console.log('ToolTiptext')
          return (
            <>
              <table key={i} className={classesItem.tooltipTable}>
                {HeaderTable}
                <tr>
                  <th className={classesItem.tooltipTable_th}></th>
                  <th className={classesItem.tooltipTable_th}>
                    {'No Data Found'}
                  </th>
                  <th className={classesItem.tooltipTable_th}>{''}</th>
                </tr>
              </table>
            </>
          );
        } else {
          return (
            <>
              <table className={classesItem.tooltipTable}>
                {HeaderTable}
                {childDataKey.map((child, i) => {
                  if (childRequiredData[i]) {
                    return (
                      <tr>
                        <th className={classesItem.tooltipTable_th}>{child}</th>
                        <td className={classesItem.tooltipTable_td}>
                          {childRequiredData[i]}
                        </td>
                        <td className={classesItem.tooltipTable_td}>
                          {childData[i]}
                        </td>
                      </tr>
                    );
                  } else {
                    return '';
                  }
                })}
              </table>
            </>
          );
        }
      }
    });

  const RenderTreeWithCheckboxes = (nodes) => {
    console.log('nodes', nodes);
    return (
      <>
        {nodes && (
          <BlueOnGreenTooltip
            title={<ToolTiptext nodes={nodes} />}
            placement="left"
            disableHoverListener={!nodes.Required}
          >
            <TreeItem
              key={nodes.id}
              nodeId={nodes.id}
              label={
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selected.some((item) => item === nodes.id)}
                      onChange={(event) =>
                        getOnChange(event.currentTarget.checked, nodes)
                      }
                    //onClick={(e) => e.stopPropagation()}
                    />
                  }
                  label={<>{nodes.name}</>}
                  key={nodes.id}
                />
              }
            >
              {Array.isArray(nodes?.children)
                ? nodes?.children.map((node) => RenderTreeWithCheckboxes(node))
                : null}
            </TreeItem>
          </BlueOnGreenTooltip>
        )}
      </>
    );
  };

  return (
    <>
      <b>Subjects</b>
      {dataNew && <Box>
        <FormControlLabel
          control={
            <Checkbox
              checked={selected?.includes(SUBJECT_UNASSIGNED)}
              onChange={handleUnassigned}
            //onClick={(e) => e.stopPropagation()}
            />
          }
          label={<>{SUBJECT_UNASSIGNED}</>}
          key={SUBJECT_UNASSIGNED}
        />
      </Box>}
      {dataNew && (
        <TreeView
          aria-label="subject selector"
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          // defaultExpanded={['0']}
          //   sx={{ height: 110, flexGrow: 1, maxWidth: 400, overflowY: 'auto' }}
          expanded={expanded}
          // selected={selected}
          onNodeToggle={handleToggle}
          // onNodeSelect={handleSelect}
          multiSelect
        >
          {RenderTreeWithCheckboxes(dataNew)}
        </TreeView>
      )}
    </>
  );
}
